import { chooseCardSampled, mcDecisionSeed } from "@ravalmatic/bridge-engine/ai/browser";
import { MC_SAMPLES, PLAY_NOISE } from "@ravalmatic/bridge-engine/ai/difficulty";
import type { SettableDifficulty } from "@ravalmatic/bridge-engine/ai/difficulty";
import { partnerOf } from "@ravalmatic/bridge-engine/core";
import type { Call, Card, Deal, PlayState } from "@ravalmatic/bridge-engine/core";
import { Difficulty } from "../../Types";
import { LOCAL_PLAYER_SEAT } from "./PlayerSeats";

export type BotPlayContext = {
    readonly deal: Deal;
    readonly state: PlayState;
    readonly legalCards: readonly Card[];
    readonly calls: readonly Call[];
    readonly seed: string;
    readonly boardNumber: number;
    readonly difficulty: Difficulty;
};

export type BotPlayStrategy = (context: BotPlayContext) => Card | Promise<Card>;

const PLAY_DIFFICULTIES: Record<Difficulty, SettableDifficulty> = {
    [Difficulty.EASY]: "beginner",
    [Difficulty.MEDIUM]: "intermediate",
    [Difficulty.HARD]: "expert"
};

export function chooseSampledCard(context: BotPlayContext): Promise<Card> {

    const partner = context.state.turn === partnerOf(LOCAL_PLAYER_SEAT);
    const difficulty = partner ? "expert" : PLAY_DIFFICULTIES[context.difficulty];
    if (!difficulty) {
        throw new Error(`Unknown card-play difficulty: ${context.difficulty}`);
    }
    const samples = MC_SAMPLES[difficulty];
    return chooseCardSampled(context.deal, context.state.contract, context.state.plays, {
        k: partner ? samples.kPartner : samples.kOpp,
        seed: mcDecisionSeed(context.seed, context.boardNumber, context.state.plays.length),
        dealer: context.deal.dealer,
        calls: [...context.calls],
        useAuction: samples.auctionAware,
        playTopN: PLAY_NOISE[difficulty].topN
    });
}

export function chooseFirstLegalCard(context: BotPlayContext): Card {

    const card = context.legalCards[0];
    if (card === undefined) {
        throw new Error("No legal card available for automatic play");
    }
    return card;
}
